import React from "react";
import { Box, Typography, Divider, Fade } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import aboutImage from "../Images/aboutImage.jpg";

const About = () => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${aboutImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "20vh",
        py: 8,
        px: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        zIndex: 1,
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: -1,
        },
      }}
    >
      <Fade in timeout={1000}>
        <Box sx={{ maxWidth: "900px", textAlign: "center", color: "#f0f0f0" }}>
          {/* About Us Heading */}
          <Typography
            variant="h3"
            fontWeight="bold"
            sx={{
              mb: 1,
              color: "rgb(198, 40, 40)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
            }}
          >
            <InfoOutlinedIcon sx={{ fontSize: "2.5rem" }} />
            About Us
          </Typography>

          <Divider
            sx={{
              width: "80px",
              mx: "auto",
              borderBottomWidth: 3,
              borderColor: "rgb(198, 40, 40)",
              mb: 4,
            }}
          />

          <Typography
            variant="body1"
            sx={{
              fontSize: "1.2rem",
              color: "#d0d0d0",
              mb: 4,
              lineHeight: 1.8,
            }}
          >
            At Third Axis, we specialize in transforming ideas into real
            products. Whether you are a startup, entrepreneur, or established
            business, we provide end-to-end product development solutions: from
            ideation, design, and prototyping to batch production. With our
            industrial-grade machines and expert team, we focus on quality,
            accuracy, and speed. From functional prototypes to large-scale batch
            production. Third Axis is your trusted partner in innovation.
          </Typography>

          {/* Vision Section */}
          <Box sx={{ my: 6 }}>
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{
                mb: 2,
                color: "rgb(198, 40, 40)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
              }}
            >
              <VisibilityOutlinedIcon />
              Our Vision
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "1.15rem",
                color: "#bbbbbb",
                lineHeight: 1.7,
              }}
            >
              To shape the future of manufacturing by making 3D printing
              accessible, sustainable, and limitless—empowering creators,
              innovators, and industries to build a smarter, more personalized
              world.
            </Typography>
          </Box>

          {/* Mission Section */}
          <Box>
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{
                mb: 2,
                color: "rgb(198, 40, 40)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
              }}
            >
              <FlagOutlinedIcon />
              Our Mission
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "1.15rem",
                color: "#bbbbbb",
                lineHeight: 1.7,
              }}
            >
              To deliver innovative, high-quality 3D printing solutions that
              accelerate design, enhance creativity, and drive progress across
              industries—through cutting-edge technology, expert collaboration,
              and an unwavering commitment to customer success.
            </Typography>
          </Box>
        </Box>
      </Fade>
    </Box>
  );
};

export default About;
